import { IApplicationState } from '../../../../../types/types';
import { getAuthUserMetaMyWork } from '../../../../../store/model/selectors/getAuthUserMetaMyWork';
import { IBoardsFetchCard } from '../../../../../types/rest/IUserMeta';

export const getMyWorkBoardsFetchCardsOptions = (
    state: IApplicationState
): IBoardsFetchCard => {
    return getAuthUserMetaMyWork(state).boardsFetchCards || {};
};
